import * as React from 'react';
import { Fragment } from 'react';
import { Header } from '../components/header';
import { Alarm, reportRequest, Winder, DATA_REFRESH_TIME } from '../api/dataTypes';
import { getAlarmsApi} from '../api/api-alarms';
import Toggle from 'react-toggle';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AlarmsTable } from '../components/table-alarms';
import { SystemSelectList } from '../components/selectSystem';
import { PromiseHelper } from '../classes/promiseHelper';
import { getAllWindersApi } from '../api/api-winder';

interface State {
    systems: Winder[];
    alarmRequest: reportRequest;
    includeInactive: boolean;
    alarmData: Alarm[] | null;
    message: string;
}

export interface Props {
}

export class AlarmsPage extends React.Component<Props, State> {

    alarmPromise: PromiseHelper<Alarm[]> = new PromiseHelper();
    winderPromise: PromiseHelper<Winder[]> = new PromiseHelper();
    dataTimerId: number | null = null;

    constructor(props: Props) {
        super(props);

        this.state = {
            systems: [],
            alarmRequest: {
                startDate: moment(new Date(Date.now()))
                    .subtract(7, "days")
                    .toDate(),
                endDate: new Date(Date.now()),
                systemId: 0,
                org: 0,
            },
            alarmData: null,
            includeInactive: true,
            message: 'loading...'
        }
    }

    componentDidMount() {
        this.getAlarms(this.state.alarmRequest);
        this.getSystems();
        this.dataTimerId = window.setInterval(this.getAlarms, DATA_REFRESH_TIME);
    }

    componentWillUnmount() {
        this.alarmPromise.clearPromise();
        this.winderPromise.clearPromise();
        if (this.dataTimerId !== null) {
            clearInterval(this.dataTimerId);
            this.dataTimerId = null;
        }
    }

    render() {
        return (
            <Fragment>
                <Header />
                <div className="d-flex header-page-title ">
                    <div className="m-2 ml-3 mr-auto">
                        Alarms
                    </div>
                </div>

                <div className="row dropdown-header-style">
                    <div className="">
                        <span className="m-3 align-middle dropdown-text-style">
                            Include Inactive Alarms
                        </span>
                        <label className="d-inline-flex " style={{ 'cursor': 'pointer' }}>
                            <Toggle
                                className="date-entry-style"
                                icons={false}
                                checked={this.state.includeInactive}
                                onChange={(e: React.SyntheticEvent<HTMLInputElement>) => {
                                    // if (e.currentTarget.checked === true) {
                                    //     this.getAlarms(this.state.alarmRequest);
                                    // }
                                    this.setState({
                                        includeInactive: e.currentTarget.checked
                                    });
                                }}
                            />
                        </label>
                    </div>
                    <div className="d-flex ml-4">
                        <div className="m-2 dropdown-text-style">Start Date</div>
                        <DatePicker
                            className="date-entry-style"
                            required={true}
                            selected={this.state.alarmRequest.startDate}
                            onChange={(d) => { if (d) { this.updateStartDate(d) } }}
                        />
                    </div>
                    <div className="d-flex ml-4">
                        <div className="m-2 dropdown-text-style">End Date</div>
                        <DatePicker
                            className="date-entry-style"
                            selected={this.state.alarmRequest.endDate}
                            onChange={(d) => { if (d) { this.updateEndDate(d) } }}
                        />
                    </div>
                </div>
                <div className="row page-standard">
                    <div className="col-3 right-divider">
                        <SystemSelectList
                            systems={this.state.systems}
                            updateSystemSelection={(system: number) => {
                                let request = this.state.alarmRequest;
                                request.systemId = system;
                                this.getAlarms(request);
                            }}
                            loading={this.state.systems.length === 0}
                        />
                    </div>
                    <div className="col-9">
                        <AlarmsTable
                            alarms={this.state.includeInactive
                                    ? this.state.alarmData
                                    : this.state.alarmData && this.state.alarmData.filter(a => a.isActive)}
                            //ackAlarm={this.ackAlarm}
                            loading={this.state.alarmData === null}
                        />
                    </div>
                </div>

            </Fragment>
        )
    }

    private getSystems = () => {
        this.winderPromise.newPromise(
            getAllWindersApi(),
            result => {
                // Don't update the state if the promise has been cleared
                if (this.winderPromise) {
                    this.setState({ systems: result });
                }
            },
            e => {
                if (this.winderPromise) {
                    alert(`Error retrieving systems. ${e!.message}`)
                }
            }
        );
    };

    private updateStartDate = (e: Date) => {
        // Ignore any old alarm request if there was one
        this.alarmPromise.clearPromise();
        // create new request object
        let nextRequest = this.state.alarmRequest;
        nextRequest.startDate = moment(e).toDate();
        // Call api to get alarms for new request parameters
        this.getAlarms(nextRequest);
        return e;
    };

    private updateEndDate = (e: Date) => {
        this.alarmPromise.clearPromise();

        let nextRequest = this.state.alarmRequest;
        nextRequest.endDate = moment(e).toDate();
        this.getAlarms(nextRequest);
        return e;
    };

    private getAlarms = (request: reportRequest | null) => {
        this.alarmPromise!.newPromise(
            getAlarmsApi(request || this.state.alarmRequest),
            result => {
                this.setState({
                    alarmRequest: request || this.state.alarmRequest,
                    alarmData: result,
                    message: ''
                });
            },
            e => {
                console.log(`Error caught in page-alarms.getAlarms(). ${e!.message}`);
                alert('Error getting alarms');
            }
        );
    }

    // private ackAlarm = (alarm: Alarm) => {
    //     ackAlarmApi(alarm)
    //         .then((result) => {
    //             if (result) {
    //                 this.setState({
    //                     message: 'Acknowledge request sent to ' +
    //                         alarm.systemName + ' for ' + alarm.message
    //                 });
    //             }
    //             this.getAlarms(this.state.alarmRequest);
    //         });
    // }
}